import { Controller } from 'stimulus'
import './yes_no_component.scss'

export default class extends Controller {
  static classes = ['selected']
  static targets = ['checkbox', 'yes', 'no', 'hidden']
  static values = { activateByDefault: Boolean }

  connect() {
    if (this.activateByDefaultValue) this.updateButtons()
  }

  yes() {
    this.checkboxTarget.checked = true
    this.setHiddenFallbackDisabled(true)
    this.triggerChange()
    this.updateButtons()
  }

  no() {
    this.checkboxTarget.checked = false
    this.setHiddenFallbackDisabled(false)
    this.triggerChange()
    this.updateButtons()
  }

  // Private
  setHiddenFallbackDisabled(disabled) {
    if (this.hasHiddenTarget) this.hiddenTarget.disabled = disabled
  }

  triggerChange() {
    this.checkboxTarget.dispatchEvent(new Event('input', { bubbles: true }))
  }

  updateButtons() {
    if (this.checkboxTarget.checked) {
      this.yesTarget.classList.add(...this.selectedClasses)
      this.noTarget.classList.remove(...this.selectedClasses)
    } else {
      this.noTarget.classList.add(...this.selectedClasses)
      this.yesTarget.classList.remove(...this.selectedClasses)
    }
  }
}
